import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebaseConfig"; 
import { Grid, Card, CardMedia, CardContent, Typography, Button } from "@mui/material";
import Barcode from "react-barcode";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default function Catalogo() {
  const [refacciones, setRefacciones] = useState([]);

  useEffect(() => {
    const fetch = async () => {
      const res = await getDocs(collection(db, "refacciones"));
      const data = res.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setRefacciones(data);
    };
    fetch();
  }, []);

  const exportToPDF = async () => {
    const input = document.getElementById("catalogo-pdf");
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const imgProps = pdf.getImageProperties(imgData);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("catalogo-refacciones.pdf");
  };

  return (
    <>
      <Button onClick={exportToPDF} sx={{ mb: 2 }} variant="contained">
        Exportar catálogo a PDF
      </Button>
      <div id="catalogo-pdf">
        <Grid container spacing={2}>
          {refacciones.map((ref) => (
            <Grid item xs={12} sm={6} md={4} key={ref.id}>
              <Card>
                {ref.imagenUrl && (
                  <CardMedia
                    component="img"
                    height="180"
                    image={ref.imagenUrl}
                    alt={ref.nombre}
                  />
                )}
                <CardContent>
                  <Typography variant="h6">{ref.nombre}</Typography>
                  <Typography>{ref.descripcion}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Precio: ${ref.precioVenta}
                  </Typography>
                  <Barcode value={ref.codigoBarras || ref.id} width={1} height={30} fontSize={10} />
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </div>
    </>
  );
}
